import { useEffect, useRef } from "react";

const KIND = {
  hand: "text-amber-400 font-bold uppercase tracking-wider text-[11px] pt-3 border-t border-white/5",
  street: "text-cyan-300 font-semibold",
  win: "text-emerald-400 font-semibold",
  bust: "text-red-400 font-semibold",
  show: "text-slate-200",
  deal: "text-amber-200",
  action: "text-slate-400",
};

export const ActionLog = ({ log }) => {
  const ref = useRef(null);
  useEffect(() => { if (ref.current) ref.current.scrollTop = ref.current.scrollHeight; }, [log.length]);
  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="px-4 py-3 text-[11px] uppercase tracking-[0.2em] text-slate-500 border-b border-white/5">Hand History</div>
      <div ref={ref} data-testid="action-log-container" className="flex-1 overflow-y-auto px-4 py-2 space-y-1 font-mono text-xs">
        {log.filter((e) => e.kind !== "hidden").map((e) => (
          <div key={e.id} className={KIND[e.kind]}>{e.text}</div>
        ))}
      </div>
    </div>
  );
};
